import { LEAD_RATING_DEFS } from '@goyone/shared';

/**
 * ميتر التصنيف — بارد ودافئ وساخن بألوانها، للملفّين سواء.
 *
 * كان محفورًا في ملف العميل المحتمل، وملف العميل يريده بعينه: خلايا
 * كأزرار المراحل تُعبَّأ بتدرّجٍ يمرّ على المحطات بترتيبها — لبنيُّ
 * البارد فبرتقاليُّ الدافئ فأحمر الساخن — والنقر يبدّل التصنيف في
 * مكانه. المكوّن واحد فلا ميتران يفترقان لونًا أو سلوكًا.
 */

const RATE_METER_STOPS: Record<string, string[]> = {
  COLD: ['#49B6EA'],
  WARM: ['#49B6EA', '#F2842B'],
  HOT: ['#49B6EA', '#F2842B', '#D63A3A'],
};

/** مزج لونين ست عشريين بنسبة t. */
function lerpHex(a: string, b: string, t: number): string {
  const pa = [1, 3, 5].map((i) => parseInt(a.slice(i, i + 2), 16));
  const pb = [1, 3, 5].map((i) => parseInt(b.slice(i, i + 2), 16));
  return `#${pa
    .map((x, k) =>
      Math.round(x + (pb[k]! - x) * Math.min(1, Math.max(0, t)))
        .toString(16)
        .padStart(2, '0'),
    )
    .join('')}`;
}

/** لونٌ عند t على مسار محطاتٍ متتابعة — مزجٌ داخل كل مقطع على حدة. */
function lerpStops(stops: string[], t: number): string {
  if (stops.length === 1) return stops[0]!;
  const pos = Math.min(1, Math.max(0, t)) * (stops.length - 1);
  const i = Math.min(Math.floor(pos), stops.length - 2);
  return lerpHex(stops[i]!, stops[i + 1]!, pos - i);
}

export function RatingMeter({
  rating,
  pending,
  onChange,
}: {
  rating: string;
  pending?: boolean;
  onChange: (rating: 'HOT' | 'WARM' | 'COLD') => void;
}) {
  const defs = [...LEAD_RATING_DEFS].reverse(); // بارد → دافئ → ساخن
  const idx = defs.findIndex((r) => r.key === rating);
  const stops = RATE_METER_STOPS[rating] ?? ['#49B6EA'];

  return (
    <span className="ratebar" role="group" aria-label="الأولوية">
      {defs.map((r, j) => {
        const filled = idx >= 0 && j <= idx;
        const bg = filled ? lerpStops(stops, idx === 0 ? 1 : j / idx) : undefined;
        return (
          <button
            key={r.key}
            type="button"
            className={`stage-step${r.key === rating ? ' current' : filled ? ' done' : ''}`}
            style={bg ? { background: bg, borderColor: bg } : undefined}
            onClick={() => rating !== r.key && onChange(r.key)}
            disabled={pending}
            aria-pressed={r.key === rating}
          >
            {r.label}
          </button>
        );
      })}
    </span>
  );
}
